<template>
  <tabBar :idIndex="5" ></tabBar>
  <News :flag="false"></News>

  <bottom></bottom>
</template>
<script setup>
import tabBar from '@/components/tabBar/tabIndex.vue'
import Bottom from '@/components/bottom/footNavigation.vue'
import News from '@/views/Page/News.vue'


</script>
<style lang="scss" scoped>

</style>
